export default __webpack_public_path__ + "static/1_9-54b8b042a5eace0d856573c085457ec4.png";